import { trpc } from "../../utils/trpc"

export const useCreateTag = () => {
  const utils = trpc.useContext()
  return trpc.tags.create.useMutation({
    onSuccess: () => {
      utils.tags.all.invalidate()
    },
  })
}